import { Location } from 'history';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { InsuranceName, QueryParamKeys } from '../types';

const qidPrefix = {
  [InsuranceName.Car]: 'COMO',
  [InsuranceName.Home]: 'COHO',
  [InsuranceName.Landlord]: 'COLA',
};

const validateQID = (
  {
    qid,
    pid,
    cid,
  }: {
    qid: string;
    pid: string;
    cid: string;
  },
  insuranceName: InsuranceName
) => {
  if (qid.length >= 4 && qidPrefix[insuranceName] === qid.slice(0, 4)) {
    return { qid, pid, cid };
  }

  return { qid: '', pid, cid };
};

export const getCampaignQueryParams = (location: Location) => {
  const urlSearchParams = new URLSearchParams(location.search);

  return {
    qid: urlSearchParams.get(QueryParamKeys.qid) ?? '',
    pid: urlSearchParams.get(QueryParamKeys.pid) ?? '',
    cid: urlSearchParams.get(QueryParamKeys.cid) ?? '',
  };
};

export const useMarketingCampaignParams = (
  onSetPrefilledPromoCode: (pid: string) => void,
  onRetrieveCampaign: (campaignId: string) => void,
  onSetColesCampaignCode: (cid: string) => void,
  insuranceName: InsuranceName
) => {
  const [{ qid, pid, cid }] = useState(
    validateQID(getCampaignQueryParams(useLocation()), insuranceName)
  );

  useEffect(() => {
    if (pid?.length) {
      onSetPrefilledPromoCode(pid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pid]);

  useEffect(() => {
    if (qid?.length) {
      onRetrieveCampaign(qid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qid]);

  useEffect(() => {
    if (cid?.length) {
      onSetColesCampaignCode(cid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cid]);

  return [qid, pid, cid];
};
